import { createContext } from "react";

const SectionContext = createContext();

export default SectionContext;
